// extracted by mini-css-extract-plugin
module.exports = {"childAccessorialsIndent":"Accessorials_childAccessorialsIndent__He5PZ"};